import ProjectsTable from './ProjectsTable';
import ProjectsRows from './ProjectsRows';
import ProjectsColumns from './ProjectsColumns';

export default ProjectsTable;

export {
  ProjectsRows,
  ProjectsColumns
};
